import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "detail" or "summary"
  data_source?: string;    // "bulk", "sample_sale", "all", "sample_order"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  sc_no_from?: string;
  sc_no_to?: string;
  delivery_from?: string;  // YYYY-MM-DD
  delivery_to?: string;    // YYYY-MM-DD
  dept_from?: string;
  dept_to?: string;
  sales_from?: string;
  sales_to?: string;
  customer_from?: string;
  customer_to?: string;
  product_from?: string;
  product_to?: string;
}

export interface ReportRow {
  FC110_10: string;       // dept code
  dept_name: string;
  FC110_13: string;       // sales code
  sales_name: string;
  FC110_59: string;       // customer code
  FC110_12: string;       // order customer
  FC110_17: string;       // brand customer
  FC110_01: string;       // SC no
  FC110_11: string;       // SC date
  FC111_12: string;       // delivery date
  product_code: string;
  FC111_14: string;       // unit
  FC111_13: number;       // qty
  FC110_24: string;       // currency
  FC110_25: number;       // exchange rate
  FC111_16: number;       // foreign amount
  sell_gross: number;
  FC111_37: number;       // purchase amount
  FC111_35: number;       // normal fee
  'FC111_3637': number;   // commission
  profit_yg: number;      // gross profit
  profit: number;         // net profit
  profit_yg_pct: number;  // gross margin %
  profit_pct: number;     // net margin %
  cost_pct: number;       // cost %
}

export interface GroupCount {
  code: string;
  name: string;
  count: number;
}

export interface CurrencySummary {
  currency: string;
  total_fgn_amt: number;
  total_sell: number;
  total_purchase: number;
  total_profit: number;
  avg_margin: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: GroupCount[];
  currency_summary: CurrencySummary[];
  message?: string;
}

export const c358Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c358/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/c358/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
